export const TABLE_VIEW_DEFAULTS = {
    ROW_ID: 'id',
    STICKY_HEADER: true,
    ROWS_PER_PAGE: 200,
    ENABLE_COLUMN_RESIZING: true,
    SHOW_PAGINATION: false,
} as const;

